import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./BlogList.css";

const posts = [
  {
    slug: 'A-Blueprint',
    img: 'blog1.jpg',
    title: 'Designing Immersive Experience Centers: A Blueprint for Emotional Impact',
    author: 'Gautam Tewari',
    date: '10 July, 2025',
  },
  
  {
    slug: 'Boosting-Workplace',
    img: 'blog2.png',
    title: 'Boosting Workplace Performance: Lessons from High-Performance Office Environments',
    author: 'Gautam Tewari',
    date: '28 June, 2025',
  },
  {
    slug: 'Trezi',
    img: 'blog3.jpg',
    title: 'Smartvizx in Action: How Virtual Walkthroughs Revolutionize Design and Delivery',
    author: 'Gautam Tewari',
    date: '25 June, 2025',
  },
  {
    slug: 'Sustainable',
        img: 'blog4.png',
    title: 'Sustainable Design in Experience Centers and Offices: Form Meets Responsibility',
    author: 'Gautam Tewari',
    date: '22 June, 2025',
  },
  {
    slug: 'VR-RealEstate',
    img: '200717-1.jpg',
    title: 'Virtual Reality: Shaping the Future of Real Estate Transactions',
    author: 'SmartVizX Team',
    date: '20 July, 2017',
  },
  {
    slug: 'VR-Buyers-Sellers',
        img: '280617-1.png',

    title: 'Virtual Reality: Bridging the gap between buyers and sellers',
    author: 'SmartVizX Team',
    date: '28 June, 2017',
  },
  {
    slug: 'VR-Design-Build',
    title: 'Virtual Reality Design Software & VR Aided Build',
    author: 'SmartVizX Team',
    date: '30 December, 2016',
  },
  {
    slug: 'ViViz-VR',
    title: 'ViViz VR - Harnessing the power of Mobile Virtual Reality Solutions for business',
    author: 'SmartVizX Team',
    date: '28 December, 2016',
  },
  {
    slug: 'VR-Empowering-Consumers',
    title: 'Virtual Reality Empowering Consumers',
    author: 'SmartVizX Team',
    date: '02 Aug, 2016',
  },
];
export default function BlogList() {
  return (
    <>
      <Navbar />

      <main className="lux-blog">
        <section className="lux-hero">
          <h1>Journal</h1>
          <p>
            Perspectives on spatial technology, immersive environments,
            and the evolving future of design.
          </p>
        </section>

        <section className="lux-grid">
          {posts.map((p, i) => (
            <article key={i} className="lux-card">
              <Link to={`/blog/${p.slug}`}>
            {p.img ? (
  <div
    className="lux-image"
    style={{
      background: `url(/img/blog/${p.img}) center / cover no-repeat`,
    }}
  />
) : (
  <div className="lux-no-image">
    <span>Read Article</span>
  </div>
)}

                <div className="lux-content">
                  <h2>{p.title}</h2>
                  <span>
                    {p.author} - {p.date}
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </section>
      </main>

      <Footer />
    </>
  );
}